import { CreateUserWatchPreferenceDto } from './create-user-watch-preference.dto';

export class UpdateUserWatchPreferenceDto extends CreateUserWatchPreferenceDto {}
